/**
 * Listen for the Outlook OAuth popup's completion message via THREE channels,
 * mirroring googleOAuthBridge.js — same pattern, different channel/key names.
 *
 * Usage:
 *   const stop = listenForOutlookConnect(({ type, code, inboxId, connectedInbox }) => {
 *     // handle result — type is "MICROSOFT_CONNECT_INBOX" or "MICROSOFT_ADDSCOPE_INBOX"
 *   });
 *   // later: stop();
 */

const STORAGE_KEY = "outlook_connect_inbox_result";
const CHANNEL_NAME = "outlook_connect_inbox";
const OUTLOOK_TYPES = ["MICROSOFT_CONNECT_INBOX", "MICROSOFT_ADDSCOPE_INBOX"];

export const listenForOutlookConnect = (callback) => {
  if (typeof callback !== "function") return () => {};

  let lastTs = 0;
  const handle = (msg) => {
    if (!msg || !OUTLOOK_TYPES.includes(msg.type)) return;
    if (msg._ts && msg._ts === lastTs) return;
    if (msg._ts) lastTs = msg._ts;
    callback(msg);
  };

  const onMessage = (ev) => handle(ev?.data);
  window.addEventListener("message", onMessage);

  let bc;
  try {
    bc = new BroadcastChannel(CHANNEL_NAME);
    bc.onmessage = (ev) => handle(ev?.data);
  } catch (e) {}

  const onStorage = (ev) => {
    if (ev.key !== STORAGE_KEY || !ev.newValue) return;
    try { handle(JSON.parse(ev.newValue)); } catch (e) {}
  };
  window.addEventListener("storage", onStorage);

  // Consume if popup raced ahead of our listener and already wrote a result.
  try {
    const cached = localStorage.getItem(STORAGE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed?._ts && Date.now() - parsed._ts < 30000) {
        handle(parsed);
      }
    }
  } catch (e) {}

  return () => {
    window.removeEventListener("message", onMessage);
    window.removeEventListener("storage", onStorage);
    try { if (bc) bc.close(); } catch (e) {}
  };
};

export const clearOutlookConnectSignal = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
};

export default listenForOutlookConnect;
